import responsiveImage from './responsive-image';

const renderProductCard = (product, helpers, collectionHandle) => {
  const productLink = product.__tagalys_fields.link;
  const productPrice = helpers.getPrice ? helpers.getPrice(product) : product.price;
  const productCompareAtPrice = helpers.getCompareAtPrice
    ? helpers.getCompareAtPrice(product)
    : product.compare_at_price;

  // Product Images
  const imgSizes =
    '(min-width: 1351px) calc(1350px / 4), (min-width: 992px) calc(100vw / 4), (min-width: 768px) calc(100vw / 3), 50vw';
  const imgAspectRatio = 'portrait';
  const imgDefaultAlt = product.title;

  let featuredImage = product.images[0];

  if (collectionHandle) {
    const imagesAlt = product.images.reduce((accumulator, image) => {
      if (image.alt) {
        accumulator += image.alt;
      }
      return accumulator;
    }, '');

    if (imagesAlt?.includes(collectionHandle)) {
      const imagesReverse = [...product.images].reverse();
      let foundCustomImage = false;

      for (const image of imagesReverse) {
        if (!image.alt) continue;

        const imageAlt = image.alt.split(',');

        for (const item of imageAlt) {
          if (item === collectionHandle) {
            featuredImage = image;
            foundCustomImage = true;
            break;
          }
        }

        if (foundCustomImage) {
          break;
        }
      }
    }
  }

  let featuredImageRender = null;
  if (featuredImage) {
    const featuredImageAlt = featuredImage.alt || imgDefaultAlt;
    featuredImageRender = `<a href="${productLink}">
      ${responsiveImage(featuredImage, featuredImageAlt, 800, true, imgSizes, imgAspectRatio)}
    </a>`;
  }

  let imageSlider = '';
  if (product.images.length > 1) {
    product.images.forEach((image) => {
      const altText = image.alt || imgDefaultAlt;
      imageSlider += `<div class="product-card__slide">
        <a href="${productLink}">
          ${responsiveImage(image, altText, 800, true, imgSizes, imgAspectRatio)}
        </a>
      </div>`;
    });
  }

  // Product Badge
  const showCustomBadges = window.theme?.product?.showCustomBadges;
  const showSoldOutBadges = window.theme?.product?.showSoldOutBadges;
  const showOnSaleBadges = window.theme?.product?.showOnSaleBadges;
  const customBadgeLabel = product.metafields?.badge?.label?.value;
  const customBadgeBgColour = product.metafields?.badge?.background_colour?.value;
  const customBadgeTextColour = product.metafields?.badge?.text_colour?.value;
  let badge = '';

  if (showCustomBadges && customBadgeLabel) {
    let badgeStyle = '';
    if (customBadgeBgColour) {
      badgeStyle += `background-color:${customBadgeBgColour};`;
    }
    if (customBadgeTextColour) {
      badgeStyle += `color:${customBadgeTextColour};`;
    }
    badge = `<div class="badge" ${badgeStyle ? `style="${badgeStyle}"` : ''}>${customBadgeLabel}</div>`;
  } else if (showSoldOutBadges && !product.available) {
    badge = `<div class="badge badge--sold-out">${window.theme?.strings?.product?.soldOutBadge}</div>`;
  } else if (showOnSaleBadges && productCompareAtPrice > productPrice) {
    badge = `<div class="badge badge--sale">${window.theme?.strings?.product?.saleBadge}</div>`;
  }

  // Product Variants
  const sizeOptionIndex = product.options_with_values.findIndex((option) => option.name.toLowerCase() === 'size');

  let variants = '';
  if (sizeOptionIndex > -1) {
    product.variants.forEach((variant, index) => {
      const variantClass = `product-card__variant ${!variant.available ? 'product-card__variant--disabled' : ''}`;
      const variantURL = `${productLink}?variant=${variant.id}`;
      variants += `<a class="${variantClass}" href="${variantURL}">${variant[`option${sizeOptionIndex + 1}`]}</a>`;
    });
  }

  const hasMoreColours = product.metafields?.details?.more_colours;

  const firstAvailableVariant = product.variants.find((variant) => variant.available);

  const currentVariant = firstAvailableVariant || product.variants[0];

  return `
    <product-card class="product-card">
      <div class="product-card__images">
        ${
          featuredImageRender
            ? `<div class="product-card__featured-image${
                product.images.length > 1 ? ' product-card__featured-image--overlay' : ''
              }">${featuredImageRender}</div>`
            : ''
        }

        ${
          imageSlider
            ? `<div class="product-card__slider" data-slider>${imageSlider}</div>
            <div class="product-card__slider-nav">
              <button class="product-card__slider-prev btn--text btn-none" aria-label="Go to the previous slide" data-slider-prev disabled>
                <svg
                  aria-label="Chevron left icon"
                  class="icon icon-chevron-left"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="m14 18-6-6 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" vector-effect="non-scaling-stroke" />
                </svg>
              </button>
              <button class="product-card__slider-next btn--text btn-none" aria-label="Go to the next slide" data-slider-next>
                 <svg
                  aria-label="Chevron right icon"
                  class="icon icon-chevron-right"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="m10 18 6-6-6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" vector-effect="non-scaling-stroke" />
                </svg>
              </button>
            </div>`
            : ''
        }

        <status-save-button
          class="status__save-button"
          product-id=${product.id}
          variant-id=${currentVariant.id}
          data-sku=${currentVariant.sku}
          data-title=${product.title}
          data-link=${productLink}
          data-price=${productPrice}
        >
        </status-save-button>

        ${badge ? `<div class="product-card__badge">${badge}</div>` : ''}
      </div>
      <div class="product-card__meta">
        ${
          product.metafields?.okendo?.StarRatingSnippet
            ? `<div data-oke-star-rating data-oke-reviews-product-id="shopify-${product.id}">
                ${product.metafields.okendo.StarRatingSnippet.value}
              </div>`
            : ''
        }

        <div class="product-card__text">
          <h4 class="product-card__title text--regular text--small-max-md">
            <a href="${productLink}">${product.title}</a>
          </h4>

          <div class="product-card__price text--regular text--small-max-md">
            <a href="${productLink}">

              ${
                helpers.isProductPricesLoading && helpers.isProductPricesLoading()
                  ? ``
                  : `
                  ${
                    product.price_varies
                      ? `
                        <span
                          >${window.theme?.strings?.product?.priceFrom?.replace(
                            '{{ price }}',
                            helpers.formatCurrency(product.price_min)
                          )}
                        </span>
                      `
                      : `
                        ${
                          helpers.isProductOnSale(productCompareAtPrice, productPrice)
                            ? `
                              <span class="visually-hidden">${window.theme?.strings?.product?.regularPrice}</span>
                              <s data-compare-price>${helpers.formatCurrency(productCompareAtPrice)}</s>
                            `
                            : ''
                        }
                        <span data-product-price
                          ${
                            helpers.isProductOnSale(productCompareAtPrice, productPrice)
                              ? 'class="product-card__sale-price"'
                              : ''
                          }
                        >
                          ${helpers.formatCurrency(productPrice)}
                        </span>
                      `
                  }
                `
              }
            </a>
          </div>
        </div>
        ${variants ? `<div class="product-card__variants text--small text--condensed">${variants}</div>` : ''}

        ${
          hasMoreColours
            ? `<p class="product-card__stitching"><a href="${productLink}">${window.theme?.strings?.product?.moreColours}</a></p>`
            : ''
        }
      </div>
    </product-card>`;
};

export default renderProductCard;
